import { InjectionToken } from '@angular/core';
import { AuthorizatorConfig } from './authorizator.config';

export const AUTHORIZATOR_CONFIG = new InjectionToken(
  'AUTHORIZATOR_CONFIG'
);
